import React from 'react';
import { Box, Card } from '@mui/material';

export default function HoverCard3D({ children, onClick, sx, cardSx }) {
  return (
    <Box sx={{ perspective: '1100px', height: '100%', ...sx }}>
      <Card
        elevation={0}
        onClick={onClick}
        sx={{
          height: '100%',
          transformStyle: 'preserve-3d',
          transition:
            'transform 0.45s cubic-bezier(0.2, 0.85, 0.25, 1), box-shadow 0.45s',
          transform: 'rotateX(0deg) rotateY(0deg) translateZ(0)',
          '&:hover': {
            transform: 'rotateX(3deg) rotateY(6deg) translateZ(12px)',
            boxShadow:
              '0 26px 52px -14px rgba(6, 78, 59, 0.45), 0 0 0 1px rgba(255,255,255,0.08) inset',
          },
          ...cardSx,
        }}
      >
        {children}
      </Card>
    </Box>
  );
}
